import { httpRequest } from "@services/http";
import { PricesheetItem } from "@models/pricesheetitem.model";
import { PricesheetItemSerializer } from "@models/serializers/pricesheetitemSerializer";

export interface CreatePricesheetItemPayload {
  name: string;
  unit_price?: number;
  unit_type?: string;
  quantity?: number;
  journey_step_id: number;
  journey_path_id?: number | null;
  step_price?: number;
  estimated_roi?: number | null;
  sequence?: number;
  conversion_rule_text?: string;
  description?: string;
  is_mandatory?: boolean;
  has_dependency?: boolean;
  journey_step_dimension_id?: number | null;
}

export class CommandCreatePricesheetItem {
  async run(contractId: number, pricesheetId: number, payload: CreatePricesheetItemPayload): Promise<PricesheetItem> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/items/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return PricesheetItemSerializer.fromJson(response);
  }
}
